import http from '@/libs/javaAxios'
import MD5 from '@/libs/MD5'

export default class userApi extends http {
  // /**
  //  * 已售卖
  //  * @method post
  //  * @param page
  //  * @param page_size
  // 
  //  */
  // static productSellingTrade = ({ page, page_size }) => {
  //   const url = '/user/product/selling/trade';
  //   this.setLoginParams();
  //   return this.post(url, { page, page_size },true);
  // }

  /**
   * 库存明细
   * @method post
   * @param product_id 产品ID
   * @param page
   * @param page_size

   */
  static goodsStockDetail = ({ product_id, page, page_size }) => {
    const url = '/user/goods/stock/detail';
    this.setLoginParams();
    return this.post(url, { product_id, page, page_size }, true);
  }

  /**
   * 总库存
   * @method post
   * @param page
   * @param page_size

   */
  static goodsStock = ({ page, page_size }) => {
    const url = '/user/goods/stock';
    this.setLoginParams();
    return this.post(url, { page, page_size }, true);
  }

  /**
   * 正在售卖
   * @method post
   * @param page
   * @param page_size

   */
  static productSelling = ({ type, page, page_size }) => {
    let url = '';
    if (type === 1) {
      url = '/user/product/selling';
    } else {
      url = '/user/product/selling/trade';
    }
    this.setLoginParams();
    return this.post(url, { page, page_size }, true);
  }

  /**
   * 获取某商品的可用库存
   * @method post
   * @param product_id 产品ID

   */
  static goodsStockUsable = ({ product_id }) => {
    const url = '/user/goods/stock/usable';
    this.setLoginParams();
    return this.post(url, { product_id });
  }




  /**
   * 用户-获取登录信息
   * @method post

   */
  static loginInfo = () => {
    const url = '/user/login/info';
    this.setLoginParams();
    return this.post(url);
  }

  /**
   * 会员主页信息
   * @method post

   */
  static homeInfo = () => {
    const url = '/user/home/info';
    this.setLoginParams();
    return this.post(url);
  }

  /**
   * 会员分享信息
   * @method post

   */
  static shareInfo = () => {
    const url = '/user/share/info';
    this.setLoginParams();
    return this.post(url);
  }

  /**
 * 上传
 * @method post

 */
  static uploadFile(formdata, data) {
    const url = `/user/img/upload`
    this.setLoginParams();
    return this.postFile(url, data, formdata);
  }

  /**
 * 收货地址-列表
 * @method post
 * @param page
 * @param page_size

 */
  static addressList = ({ page, page_size }) => {
    const url = '/user/address/list';
    this.setLoginParams();
    return this.post(url, { page, page_size }, true);
  }

  /**
   * 收货地址-删除
   * @method post
   * @param address_id 收货地址ID

   */
  static addressDelete = (address_id) => {
    const url = '/user/address/delete';
    this.setLoginParams();
    return this.post(url, { address_id });
  }

  /**
   * 收货地址-添加
   * @method post
   * @param data

   */
  static addressAdd = (data) => {
    const url = '/user/address/add';
    this.setLoginParams();
    return this.post(url, data);
  }

  /**
   * 收货地址-编辑
   * @method post
   * @param data

   */
  static addressEdit = (data) => {
    const url = '/user/address/edit';
    this.setLoginParams();
    return this.post(url, data);
  }

  /**
   * 收货地址-详情
   * @method post
   * @param address_id 收货地址ID

   */
  static addressDetail = (address_id) => {
    const url = '/user/address/detail';
    this.setLoginParams();
    return this.post(url, { address_id });
  }

  /**
   * 普通用户佣金累计
   * @method post

   */
  static recommendMemberCommission = () => {
    const url = '/user/recommend/member/commission';
    this.setLoginParams();
    return this.post(url);
  }

  /**
   * 普通用户我的会员列表
   * @method post
   * @param page
   * @param page_size

   */
  static recommendMember = ({ page, page_size }) => {
    const url = '/user/recommend/member';
    this.setLoginParams();
    return this.post(url, { page, page_size }, true);
  }

  /**
   * 会员关系（直推 / 间推）
   * @method post
   * @param referee_id 推荐人ID，不传则取当前登录用户
   * @param indirect 1=间推（下级的下级），其它=直推
   * @param page
   * @param page_size
   *
   * 2026-10-14：由 productApi.homeProductList（C 端商品列表残留，B 端根本没这个接口）
   * 改为 B 端真实的 /user/relation，契约同步切到 Java（res.data + res.pagination.pageCount）。
   */
  static userRelation = ({ referee_id, indirect, page, page_size }) => {
    const url = '/user/relation';
    this.setLoginParams();
    return this.post(url, { referee_id, indirect, page, page_size }, true);
  }

  /**
   * 普通用户我的会员详情
   * @method post
   * @param referrer_id 被推荐用户ID
   * @param page
   * @param page_size

   */
  static recommendMemberDetail = ({ referrer_id, page, page_size }) => {
    const url = '/user/recommend/member/detail';
    this.setLoginParams();
    return this.post(url, { referrer_id, page, page_size }, true);
  }

  /**
   * 检测用户注册状态
   * @method post
   * @param phone	手机号
  **/
  static checkUserStatus = (data) => {
    const url = '/user/check_user_status';
    return this.post(url, data);
  }

  /**
   * 用户注册/登录
   * @method post
   * @param phone 注册/登录手机号
   * @param send_code 短信验证码
   * @param invitation_code 推广码
   * @param imei 手机唯一码

   */
  static login = (data) => {
    const url = '/user/login';
    return this.post(url, data, false, true);
  }

  /**
  * 用户注册/登录 密码登录
  * @method post
  * @param phone 注册/登录手机号
  * @param password 密码（AES加密）
  * @param imei 手机唯一码
 
  */
  static loginPWD = (data) => {
    const url = '/user/pwdlogin';
    return this.post(url, data, false, true);
  }

  /**
     * 用户注册/登录
     * @method post
     * @param bind_token 绑定码
     * @param phone 注册/登录手机号
     * @param send_code 短信验证码
     * @param invitation_code 推广码
     * @param imei 手机唯一码
  
     */
  static bind = (data) => {
    const url = '/user/bind';
    return this.post(url, data);
  }

  /**
   * 经销商我的会员
   * @method post
   * @param page
   * @param page_size

   */
  static recommendDealer = ({ page, page_size }) => {
    const url = '/user/recommend/dealer';
    this.setLoginParams();
    return this.post(url, { page, page_size }, true);
  }

  /**
   * 经销商我的会员详情
   * @method post
   * @param referrer_id 被推荐用户ID
   * @param page
   * @param page_size

   */
  static recommendDealerDetail = ({ referrer_id, page, page_size }) => {
    const url = '/user/recommend/dealer/detail';
    this.setLoginParams();
    return this.post(url, { referrer_id, page, page_size }, true);
  }

  /**
   * 经销商累计收入
   * @method post

   */
  static recommendDealerIncome = () => {
    const url = '/user/recommend/dealer/income';
    this.setLoginParams();
    return this.post(url);
  }

  /**
   * 退出登录
   * @method post

   */
  static logout = () => {
    const url = '/user/logout';
    this.setLoginParams();
    return this.post(url);
  }


  /**
   * 抢购列表
   * @method post
   * @type 类型 1：抢购，2：配额，3：进货
   * @param type
   * @param page
   * @param page_size

   */
  static seckillList = ({ type, page, page_size }) => {
    let url;
    if (type == 1) {
      url = '/user/quota/list';
    } else if (type == 2) {
      url = '/user/seckill/list';
    } else {
      url = '/user/allocate/list';
    }
    this.setLoginParams();
    return this.post(url, { page, page_size }, true);
  }

  /**
   * 获取订单的商品价格清单
   * @method post
   * @param trade_no 交易单号
   * @param page
   * @param page_size

   */
  static tradeMerchantList = ({ trade_no, page, page_size }) => {
    const url = '/user/trade/merchant/list';
    this.setLoginParams();
    return this.post(url, { trade_no, page, page_size });
  }

  /**
   * 订单列表
   * @method post
   * @param bill_status 订单状态（未付款-UNPAID，已付款-PAID，已发货-SEND，交易成功-SUCCESS，订单取消-CANCLE，订单失效-EXPIRED）
   * @param page
   * @param page_size

   */
  static tradeList = ({ bill_status, page, page_size }) => {
    const url = '/user/trade/list';
    this.setLoginParams();
    return this.post(url, { bill_status, page, page_size }, true);
  }

  /**
   * 订单详情
   * @method post
   * @param trade_no 交易单号

   */
  static tradeDetail = (trade_no) => {
    const url = '/user/trade/detail';
    this.setLoginParams();
    return this.post(url, { trade_no });
  }

  /**
   * 跟踪快递
   * @method post
   * @param trade_no 交易单号

   */
  static tradeExpressDetail = (trade_no) => {
    const url = '/user/trade/express/detail';
    this.setLoginParams();
    return this.post(url, { trade_no });
  }

  /**
  * 初次设置登录密码
  * @method post
  * @param password	密码（AES加密）
  * @param user_id	用户id

  */
  static setLoginPasswordFirst = (data) => {
    const url = '/user/set_login_pwd_first';
    this.setLoginParams();
    return this.post(url, data);
  }

  /**
   * 用户重置登录密码
   * @method post
   * @param password	新密码（AES加密）
   * @param phone	用户手机号
   * @param send_code	验证码
 
   */
  static resetLoginPassword = (data) => {
    const url = '/user/reset_login_pwd';
    return this.post(url, data, false, true);
  }

  /**
   * 用户修改登录密码
   * @method post
   * @param password	new_password	新密码（AES加密）
   * @param password new_password_retype	新密码二次输入（AES加密）	
   * @param passwordold_password	原密码（AES加密）
   * @param passworduser_id	用户id
 
   */
  static updatePassword = (data) => {
    const url = '/user/update_login_pwd';
    this.setLoginParams();
    return this.post(url, data);
  }
}